import { defineStore } from 'pinia';

import type { IntegrationProvider } from '@stuut/api-sdk/models';
import type { Integration } from '@stuut/api/models';
import { waitFor } from '@stuut/common/src/utils.ts';

import { stuut } from '@/api';
import { sdk } from '@/sdk.ts';

interface State {
  integrations: Integration[];
  isLoading: boolean;
  providers: IntegrationProvider[];
}

export const useIntegrations = defineStore('integrations', {
  actions: {
    async fetchIntegrations() {
      return stuut.integrations
        .list()
        .then((integrations) => {
          this.$patch({ integrations });
          return this.integrations;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async fetchProviders(): Promise<IntegrationProvider[]> {
      if (this.isLoading) {
        await waitFor(() => !this.$state.isLoading, 100);
      } else {
        try {
          const providers = await sdk.integrations.providers.list();
          this.$patch({ providers, isLoading: false });
        } finally {
          this.$patch({ isLoading: false });
        }
      }

      return this.$state.providers;
    },
  },
  getters: {
    getIntegrationByName: (state) => {
      return (integrationName: string) =>
        state.integrations.find((integration) => integration.name === integrationName);
    },
  },
  state: (): State => ({
    integrations: [],
    providers: [],
    isLoading: false,
  }),
});

export default useIntegrations;
